export { QuickAccessMenu } from './quick-access-menu';
